import { useMemo } from "react";
import Slider from "react-slick";
import { SlickProps } from "../../lib/Slick";
import Api from "utils/api/Api";
import { useQuery, keepPreviousData } from "@tanstack/react-query";

export const HomeAppleRankUp = () => {
  const { data: homeList, isFetching, isSuccess } = useQuery({
    queryKey: ['/home/apple/rankup'],
    queryFn: () => Api.get('/api/book/apple/rankup/latest'),
    staleTime: 5 * 6 * 1000, //슬라이드가 5장, 장당 6초씩 이니까 대충;;
    placeholderData: keepPreviousData
    // gcTime:1*60*1000
  });

  const rankList = useMemo(() => {
    if (isFetching) return null;
    if (!isSuccess) return null;
    if (homeList.data?.length <= 0) {
      return (
        <div className="no_data">
          <p>레벨업 친구가 없습니다.</p>
        </div>
      );
    }
    // let tempLists = _.slice(homeList.data?, 0, 5);
    return homeList.data?.map((item, key) => {
      // item.isMyRank==='Y'
      let userName = item.userName?.substring(0, 4);
      if (item.userName === null) userName = "이용자";

      return (
        <div className="slide_item" key={key}>
          <img
            src={`${process.env.PUBLIC_URL}/static/images/user/b0${parseInt(item.rankIndex, 10) + 1}.png`} alt={item.rankName}
            title={item.rankName}
          />
          <span className="name">{userName}</span>
          <span className="grade">
            {item.userGrade === null ? "0" : item.userGrade} 학년
          </span>
          <span className="school">
            {item.userSchoolName?.replace("초등학교", "초 ")} ({item.userSchoolCityName})
          </span>
        </div>
      );
    });
  }, [homeList, isFetching, isSuccess]);

  return (
    <div className="levelup_list">
      <img src={`${process.env.PUBLIC_URL}/images/main/levelup_gif.gif`} className="_gif" alt="레벨업을 축하합니다" />
      <Slider
        className="list_wrap"
        id="levelup_list"
        {...SlickProps}
        dots={true}
        arrows={false}
        dotsClass="slide_dots _blue"
        responsive={null}
        infinite={homeList?.data?.length > 5}
        vertical={true}
        verticalSwiping={true}
        swipeToSlide={true}
        adaptiveHeight={homeList?.data?.length <= 5}
      >
        {rankList}
      </Slider>
    </div>
  );
};
